var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12" },
    [
      _vm.loading
        ? _c("activity-loader")
        : [
            _vm.noActivities
              ? _c("empty-message")
              : _c(
                  "ul",
                  { staticClass: "list-group list-group-flush" },
                  _vm._l(_vm.sortedActivities, function (ref, index) {
                    var accountDetails = ref.accountDetails
                    var message = ref.message
                    var metadata = ref.metadata
                    var createdAt = ref.createdAt
                    var type = ref.type
                    var read = ref.read
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "list-group-item activity-item py-2",
                        class: { unread: !read },
                      },
                      [
                        _c("div", { staticClass: "row align-items-center" }, [
                          _c(
                            "div",
                            { staticClass: "pr-0 img col-auto" },
                            [
                              _c(
                                "profile-avatar",
                                _vm._b(
                                  {
                                    staticClass:
                                      "client-profile-owner-avatar lg",
                                    attrs: {
                                      "avatar-options": { inline: false },
                                    },
                                  },
                                  "profile-avatar",
                                  Object.assign({}, accountDetails),
                                  false
                                )
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col comment-section" }, [
                            _c(
                              "h6",
                              {
                                staticClass:
                                  "text-dark-gray activity-title mb-0",
                              },
                              [
                                _c(
                                  "client-activity-anchor",
                                  _vm._b(
                                    {},
                                    "client-activity-anchor",
                                    {
                                      accountDetails: accountDetails,
                                      metadata: metadata,
                                      type: type,
                                    },
                                    false
                                  ),
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("splitMessage")(
                                            message,
                                            metadata,
                                            "main"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-primary bold time-ago mb-0 activity-subtitle",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.formatTimeAgo(createdAt)) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }